<template>
    <div class="container">
        <div class="text-center transaction-status">
            <div class="row" v-if="loading">
                <div class="col">
                    <h1>LOADING...</h1>
                </div>
            </div>
            <div v-if="transactionStatus && !loading">
                <div class="row">
                    <div class="col">
                        <h1>Thank you for your donation. Your transaction was successful.</h1>
                    </div>
                </div>
                <div class="row buttonRow justify-content-center">
                    <div class="col-xl-3 col-lg-4 col-md-5">
                        <button type="button" class="btn btn-block backToSolidarity" v-on:click="doRedirectSol">
                            BACK TO SOLIDARITY FUND
                        </button>
                    </div>
                    <div class="col generic-spacer d-block d-xs-block d-lg-none d-md-none"></div>
                    <div class="col-xl-3 col-lg-4 col-md-5">
                        <button type="button" class="btn btn-block payButton" v-on:click="doRedirectDpo">
                            VISIT DPO SOUTH AFRICA
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="!transactionStatus  && !loading">
                <div class="row">
                    <div class="col">
                        <h1>There was a problem processing your donation, please try again.</h1>
                    </div>
                </div>
                <div class="row buttonRow justify-content-center">
                    <div class="col-xl-3 col-lg-4 col-md-5">
                        <button type="button" class="btn btn-block backToSolidarity " v-on:click="doRedirectSol">
                            BACK TO SOLIDARITY FUND
                        </button>
                    </div>
                    <div class="col generic-spacer d-block d-xs-block d-lg-none d-md-none"></div>
                    <div class="col-xl-3 col-lg-4 col- col-md-5">
                        <button type="button" class="btn btn-block payButton" v-on:click="doRedirectRetry">
                            TRY AGAIN
                        </button>
                    </div>
                </div>
            </div >
        </div>
    </div>
</template>

<script>

  var crypto = require('crypto')
  const axios = require('axios')
  import { utils } from '../utility/utility'

  export default {
    props:{
      reference: String
    },
    name: 'Response',
    data:        function (){
      return {
        transactionStatus: false,
        loading:true,
        buttonColor:  '#d23983'
      }
    },
    mounted:function(){
      this.queryTransaction()
    },
    methods:{
      queryTransaction:function(){
        const resp = localStorage.getItem('PAY_REQUEST_ID');

        let PAYGATE_ID = process.env.VUE_APP_PAYGATE_ID
        let PAY_REQUEST_ID = resp
        let REFERENCE = this.$props.reference

        let checksumValue = PAYGATE_ID + PAY_REQUEST_ID + REFERENCE +  process.env.VUE_APP_CODE

        var bodyFormData = new FormData()
        bodyFormData.set('PAYGATE_ID', PAYGATE_ID)
        bodyFormData.set('PAY_REQUEST_ID', PAY_REQUEST_ID)
        bodyFormData.set('REFERENCE', REFERENCE)
        bodyFormData.set('CHECKSUM', crypto.createHash('md5').update(checksumValue).digest('hex'))

        axios({
          url:     process.env.VUE_APP_SECURE_DOMAIN + '/payweb3/query.trans',
          method:  'POST',
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          data:    bodyFormData
        }).then((data) => {

          let response = utils.getURLParams(data.data);

          if (response){
            if (response.TRANSACTION_STATUS === '1'){
              this.transactionStatus = true
            }
          }
          this.loading = false

        }).catch((error) => {
          this.loading = false
          console.error(error)
        })
      },
      doRedirectRetry: function () {
        localStorage.setItem('PAY_REQUEST_ID','');
        window.location.href = process.env.VUE_APP_BASE_URL
      }, doRedirectSol: function () {
        window.location.href = 'https://www.solidarityfund.co.za/'
      },doRedirectDpo: function () {
        window.location.href = 'https://www.paygate.co.za?utm_source=web&utm_medium=link&utm_campaign=Solidarity&utm_content=top'
      }
    }

  }

</script>

<style>
</style>
